var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hideBoxs"},[_c('focus',{attrs:{"item":_vm.item}}),_c('mail',{attrs:{"item":_vm.item,"type":_vm.type}}),_c('im',{attrs:{"item":_vm.item}}),_c('openDetail',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }